var map = {
	"./3D Design.jpg": 2820,
	"./Art & Illustration.jpg": 2292,
	"./Brand Icon.jpg": 1084,
	"./Building Design.jpg": 596,
	"./Packaging & Covers.jpg": 7364,
	"./Web & App Design.jpg": 1392,
	"./banner.jpg": 4928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;